module.exports = {"id":"s6-q1b","text":"Does your computer have software appropriate for accessing and updating documents?","multiselect":false,"next":"s6-q1c","options":[{"id":"s6-q1b-a1","text":"Yes","capability":2,"access":2,"focusarea":[0,0,4,0,4]},{"id":"s6-q1b-a2","text":"No","capability":-2,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q1b.json
// module id = 928
// module chunks = 32